import * as z from "zod";

export const SpecialPricePeriodSchema = z.object({
  id: z.string(),
  period: z.object({
    from: z.string().transform((s) => new Date(s)),
    to: z.string().transform((s) => new Date(s)),
  }),
  price: z.number(),
  productId: z.string(),
});
export type SpecialPricePeriod = z.infer<typeof SpecialPricePeriodSchema>;
export type SpecialPricePeriodInput = z.input<typeof SpecialPricePeriodSchema>;

export const SpecialPricePeriodsSchema = z.array(SpecialPricePeriodSchema);
